import { factoryService, postJsonRequest } from '@chilecompra/react-kit'

import { PROVIDER_ROWS } from '../config/settings/constants'
import { REACT_APP_API_PRINCIPAL_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets providers by business name.
 */
export const getProvidersByBusinessName = factoryService(({ businessName, page }) => {
  const body = {
    page,
    nombre: businessName,
    size: PROVIDER_ROWS
  }

  return postJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/proveedor/nombre`, { body })
})

/**
 * Gets providers by dni.
 */
export const getProvidersByDni = factoryService(({ dni, page }) => {
  const body = {
    page,
    rut: dni,
    size: PROVIDER_ROWS,
    tipo: 1
  }

  return postJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/proveedor/rut`, { body })
})

/**
 * Gets providers by foreign Id.
 */
export const getProvidersById = factoryService(({ id, page }) => {
  const dni = normalizeDniSlashes(id)

  const body = {
    page,
    rut: dni,
    size: PROVIDER_ROWS,
    tipo: 2
  }

  return postJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/proveedor/rut`, { body })
})
